module.exports = __webpack_public_path__ + "media/images/ohap_calendar_up_arrow-4b91a50790bcb6f26c9067aec6bac2e0.png";